export default "__VITE_ASSET__BwL_bIO5__"